import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/orderExpiredReport-actions';
import { OrderExpiredReportActions } from '../constants';
import { IOrderExpiredReport } from 'src/types/orderExpiredReport';

export interface OrderExpiredReportState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IOrderExpiredReport>;
    current: IOrderExpiredReport | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function orderExpiredReports(
    state: OrderExpiredReportState = initialState,
    action: Actions | any,
): OrderExpiredReportState {
    switch (action.type) {
        case requestType(OrderExpiredReportActions.PERSIST_ORDER_EXPIRED_REPORT):
            return { ...state, error: '', inProgress: true };
        case successType(OrderExpiredReportActions.PERSIST_ORDER_EXPIRED_REPORT):
            return { ...state, inProgress: false };
        case failureType(OrderExpiredReportActions.PERSIST_ORDER_EXPIRED_REPORT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORTS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(OrderExpiredReportActions.DELETE_ORDER_EXPIRED_REPORT):
            return { ...state, error: '', inProgress: true };
        case successType(OrderExpiredReportActions.DELETE_ORDER_EXPIRED_REPORT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IOrderExpiredReport) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(OrderExpiredReportActions.DELETE_ORDER_EXPIRED_REPORT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
